'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var lp = require('it-length-prefixed');

var handshake = require('it-handshake');

var _require = require('../protocol'),
    CircuitPB = _require.CircuitRelay;

var debug = require('debug');

var log = debug('libp2p:circuit:stream-handler');
log.error = debug('libp2p:circuit:stream-handler:error');

var StreamHandler = /*#__PURE__*/function () {
  /**
   * Create a stream handler for connection
   *
   * @param {object} options
   * @param {*} options.stream - A duplex iterable
   * @param {Number} options.maxLength - max bytes length of message
   */
  function StreamHandler(_ref) {
    var stream = _ref.stream,
        _ref$maxLength = _ref.maxLength,
        maxLength = _ref$maxLength === void 0 ? 4096 : _ref$maxLength;

    _classCallCheck(this, StreamHandler);

    this.stream = stream;
    this.shake = handshake(this.stream);
    this.decoder = lp.decode.fromReader(this.shake.reader, {
      maxDataLength: maxLength
    });
  }
  /**
   * Read and decode message
   * @async
   * @returns {void}
   */


  _createClass(StreamHandler, [{
    key: "read",
    value: function () {
      var _read = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var msg, value;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.decoder.next();

              case 2:
                msg = _context.sent;

                if (!msg.value) {
                  _context.next = 7;
                  break;
                }

                value = CircuitPB.decode(msg.value.slice());
                log('read message type', value.type);
                return _context.abrupt("return", value);

              case 7:
                log('read received no value, closing stream'); // End the stream, we didn't get data

                this.close();

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function read() {
        return _read.apply(this, arguments);
      }

      return read;
    }()
    /**
     * Encode and write array of buffers
     *
     * @param {*} msg An unencoded CircuitRelay protobuf message
     */

  }, {
    key: "write",
    value: function write(msg) {
      log('write message type %s', msg.type);
      this.shake.write(lp.encode.single(CircuitPB.encode(msg)));
    }
    /**
     * Return the handshake rest stream and invalidate handler
     *
     * @return {*} A duplex iterable
     */

  }, {
    key: "rest",
    value: function rest() {
      this.shake.rest();
      return this.shake.stream;
    }
  }, {
    key: "end",
    value: function end(msg) {
      this.write(msg);
      this.close();
    }
    /**
     * Close the stream
     *
     * @returns {void}
     */

  }, {
    key: "close",
    value: function close() {
      log('closing the stream');
      this.rest().sink([]);
    }
  }]);

  return StreamHandler;
}();

module.exports = StreamHandler;